import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../../core/constants";
import {setCanvasScale} from "../../../../../actions/actionFunctions";

import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {setWizardActiveItem} from "../../../../../actions/wizardFunctions";
import {getLookIdUrl} from "../../../lookNavigation/lookFunctions2";
import {ROUTES} from "../../../../../routes";
import {zoomCanvasOut} from "../../../lookNavigation/lookFunctions";
import LookCanvasContext from "../../../lookCanvasContext";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

const GroheFeatureWizardButton = (props) => {

  const {setLookOverlayOpened, setWizardActiveItem, history, setCanvasScale, feature, hasWizard} = props;


  const featureIsLocked = getFeatureIsLocked(feature);
  const wizardButtonClick = (imageCanvas) => {
    if (featureIsLocked) {
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
      return false
    }
    setWizardActiveItem(hasWizard);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${hasWizard.id}`);
  };

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <Button className={"look-button look-button--secondary look-button--no-transform"
          + (IS_PRODUCT_JOURNEY ? " grohe-look__button" : "")
          + (featureIsLocked ? " look-button--disabled" : "")}
                disabled={featureIsLocked}
                endIcon={<AutoFixHighIcon/>}
                onClick={() => wizardButtonClick(imageCanvas)}>
              <span className="look-wizard-name-text">{hasWizard.name && hasWizard.name.length > 10
                ? hasWizard.name
                : <FormattedMessage id="wizard.start.button" values={{wizardName: hasWizard.name}}/>}</span>
        </Button>
      )}
    </LookCanvasContext.Consumer>
  )
};

GroheFeatureWizardButton.propTypes = {
  feature: PropTypes.shape(featureInterface),
  hasWizard: PropTypes.object,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    isMobile,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setWizardActiveItem,
  setCanvasScale,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureWizardButton)
)
